<template>
    <v-select dense outlined v-bind="$attrs" :items="items" item-text="name" item-value="id" v-on="$listeners" />
</template>

<script>
import { getI18nInstance as i18n } from '@/i18n';

export default {
    name: 'MagazinKachelgroesseSelect',
    data() {
        return {
            items: [
                { id: '1', name: i18n().t('one_tile') },
                { id: '2H', name: i18n().t('2_tiles_h') },
            ],
        };
    },
};
</script>
